/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Toast_Creating_ZipInputs */



/**
* | output |
* | --- |
* | "Creating zip file..." |
*
* @param {Spaces_Toast_Creating_ZipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_toast_creating_zip = /** @type {((inputs?: Spaces_Toast_Creating_ZipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Toast_Creating_ZipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("ZIP-Datei wird erstellt...")
	return /** @type {LocalizedString} */ ("Creating zip file...")
});